import { KnowledgeBaseSnippetKind } from 'types'
import { string } from 'yup'
import { safify } from '../utils/safify'

export const productName = string()
  .default('')
  .meta({
    label: 'What is the product or service called?',
    placeholder: 'Product/service name',
    snippets: [KnowledgeBaseSnippetKind.ProductOrServiceDescription],
    autoFill: true,
  })
  .transform(safify)
